// extracted by mini-css-extract-plugin
export default {"full-width-header":"full-width-header--1ew0Y","full-width-header--candy":"full-width-header--candy--H9wEq"};
    if(module.hot) {
      // 1747648146619
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  